/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Address_HomeInputs */

const en_checkout_address_home = /** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const es_checkout_address_home = /** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casa`)
};

const fr_checkout_address_home = /** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domicile`)
};

const de_checkout_address_home = /** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuhause`)
};

const id_checkout_address_home = /** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rumah`)
};

/** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */
const ja_checkout_address_home = en_checkout_address_home;

/** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */
const zh_checkout_address_home = en_checkout_address_home;

/** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */
const ar_checkout_address_home = en_checkout_address_home;

/** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */
const it_checkout_address_home = en_checkout_address_home;

/** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */
const ru_checkout_address_home = en_checkout_address_home;

/** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */
const pt_checkout_address_home = en_checkout_address_home;

/** @type {(inputs: Checkout_Address_HomeInputs) => LocalizedString} */
const ko_checkout_address_home = en_checkout_address_home;

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Checkout_Address_HomeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checkout_address_home = /** @type {((inputs?: Checkout_Address_HomeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Address_HomeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkout_address_home(inputs)
	if (locale === "es") return es_checkout_address_home(inputs)
	if (locale === "fr") return fr_checkout_address_home(inputs)
	if (locale === "de") return de_checkout_address_home(inputs)
	if (locale === "ja") return ja_checkout_address_home(inputs)
	if (locale === "zh") return zh_checkout_address_home(inputs)
	if (locale === "ar") return ar_checkout_address_home(inputs)
	if (locale === "id") return id_checkout_address_home(inputs)
	if (locale === "it") return it_checkout_address_home(inputs)
	if (locale === "ru") return ru_checkout_address_home(inputs)
	if (locale === "pt") return pt_checkout_address_home(inputs)
	return ko_checkout_address_home(inputs)
});